export const KAMPOT_PEPPER_ARTICLE = {
  path: "/blog/kampot-pepper-melbourne",
  title: "Kampot Pepper in Melbourne: Cambodia's Famous Pepper at ANGKOR West Melbourne",
  headline: "Kampot Pepper in Melbourne: Cambodia's Famous Pepper, and Where to Taste It",
  description: "What makes Kampot pepper special, how Cambodians cook with it, and where to taste it in Melbourne: Kampot Pepper Seafood and peppery Beef Loc Lac at ANGKOR, 389 Spencer St.",
  image: "/manus-storage/kampot-pepper-seafood-rice-angkor_5411d20f.webp",
  imageAlt: "Kampot Pepper Seafood with king prawns and calamari at ANGKOR West Melbourne",
  datePublished: "2026-10-26",
  dateLabel: "26 October 2026",
  byline: "By the ANGKOR team",
  excerpt: "What makes Kampot pepper special, how Cambodians cook with it, and where to taste it in Melbourne: Kampot Pepper Seafood and peppery Beef Loc Lac at ANGKOR, 389 Spencer St.",
} as const;
